module.exports = __webpack_public_path__ + "static/media/bolso (19).9871d6c8.jpg";